import React from "react";
import DashboardLayout from "../shared/Layouts/DashboardLayout";
import { Route, Routes } from "react-router-dom";
import { Registrar1AssessmentRoute } from "../features/modules/registrar1-assessment/routes/route";
import { PrivateIndividualRoute } from "../features/modules/private-individuals/routes/route";
import { LawyerRoute } from "../features/modules/lawyers/routes/route";
import { Registrar1PaymentRoute } from "../features/modules/registrar1-payment/routes/route";
import { Registrar2Route } from "../features/modules/registrar2/routes/route";
import { PresidentRoute } from "../features/modules/president/routes/route";
import { PanelRoute } from "../features/modules/panel/routes/route";
import { BaliffRoute } from "../features/modules/baliff/routes/route";
import { PoliceRoute } from "../features/modules/police/routes/route";
import { AdminRoute } from "../features/modules/admin/routes/route";

function MainRoutes() {
  return (
    <DashboardLayout>
      <Routes>
        {Registrar1AssessmentRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {Registrar2Route.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {Registrar1PaymentRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {PrivateIndividualRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {LawyerRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {PresidentRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {PanelRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {BaliffRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {PoliceRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
        {AdminRoute.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={<item.component />}
          />
        ))}
      </Routes>
    </DashboardLayout>
  );
}

export default MainRoutes;
